import apiClient from '../apiClient';
import { GET_ACCOMMODATION_ITEM_ALL_URL } from '../apiUrl';

const getAccomodationItemAllApi = () => {
  return apiClient.get(GET_ACCOMMODATION_ITEM_ALL_URL);
};

export default getAccomodationItemAllApi;
